export { default } from "./WorkNav";
export type { WorkNavPage, WorkNavProps } from "./WorkNav";
